module.exports = __webpack_public_path__ + "static/media/oir-symbol-white.5ece61f9.png";